import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import FadeIn from "@/components/FadeIn";
import SkylineDivider from "@/components/SkylineDivider";

const API = process.env.REACT_APP_BACKEND_URL;

export default function BookConfirmed() {
  const { id } = useParams();
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    fetch(`${API}/api/bookings/${id}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then(setRes)
      .catch(() => setErr("We couldn't find that request. Try refreshing, or reach out to us directly."));
  }, [id]);

  return (
    <div className="min-h-screen bg-cream" data-testid="book-confirmed">
      <section className="pt-32 pb-8 lg:pt-40 lg:pb-12">
        <div className="container-narrow">
          {err ? (
            <p className="text-clay">{err}</p>
          ) : !res ? (
            <p className="text-coal/50 italic">Loading your request…</p>
          ) : (
            <FadeIn>
              <p className="overline mb-4">Request received</p>
              <h1 className="font-serif text-4xl lg:text-6xl text-moss font-light leading-[1.05]">
                Thank you, {res.guest_first_name}.
              </h1>
              <p className="mt-6 max-w-2xl text-coal/70 leading-[1.85] text-lg">
                Your dates for <strong className="text-moss">{res.cottage_name}</strong> are held.
                We just sent a confirmation to <strong>{res.guest_email_masked}</strong> and we'll be in
                touch personally to process payment through our Clover terminal.
              </p>
              <div className="mt-10 bg-oat p-8 lg:p-10 border border-moss/10 max-w-xl" data-testid="confirmed-summary">
                <p className="overline mb-4">Your request</p>
                <div className="space-y-3 text-sm text-coal/80">
                  <Row label="Cottage" value={res.cottage_name} />
                  <Row label="Check-in" value={res.check_in} />
                  <Row label="Check-out" value={res.check_out} />
                  <Row label="Nights" value={res.nights} />
                  <Row label="Party" value={res.party_size} />
                  <Row label="Estimated total" value={`$${res.total.toFixed(2)}`} bold />
                  <Row label="Status" value={res.status} />
                </div>
              </div>
              <p className="mt-10 text-sm text-coal/55">
                Reference:{" "}
                <span className="font-mono text-moss" data-testid="reservation-id">{res.id}</span>
              </p>
              <div className="mt-10 flex gap-4">
                <Link to="/stay" className="text-moss text-sm tracking-[0.24em] uppercase border-b border-moss/40 hover:border-moss pb-1">
                  Back to cottages
                </Link>
              </div>
            </FadeIn>
          )}
        </div>
      </section>
      <SkylineDivider />
    </div>
  );
}

function Row({ label, value, bold }) {
  return (
    <div className="flex items-baseline justify-between">
      <span className="text-coal/60">{label}</span>
      <span className={bold ? "text-moss font-serif text-2xl" : "text-coal"}>{value}</span>
    </div>
  );
}
